(function() {
  function initBannerSlider(sectionId) {
    const sliderWrapper = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!sliderWrapper) return;
    
    const slides = sliderWrapper.querySelectorAll('.an-cus-banner-slide');
    const contentSlides = sliderWrapper.querySelectorAll('.an-cus-banner-content-slide');
    const dotsContainer = sliderWrapper.querySelector('.an-cus-banner-slider-dots');
    const controlsContainer = sliderWrapper.querySelector('.an-cus-banner-slider-controls');
    const dots = dotsContainer ? dotsContainer.querySelectorAll('.an-cus-banner-slider-dot') : [];
    const prevBtn = controlsContainer ? controlsContainer.querySelector('.an-cus-banner-slider-prev') : null;
    const nextBtn = controlsContainer ? controlsContainer.querySelector('.an-cus-banner-slider-next') : null;
    
    if (slides.length === 0) return;
    
    // Get settings from data attributes
    const autoplayDelay = parseInt(sliderWrapper.dataset.autoplayDelay) || 5000;
    const autoplayEnabled = sliderWrapper.dataset.autoplay === 'true';
    
    let currentSlide = 0;
    let autoplayInterval;
    
    function showSlide(index) {
      if (index < 0 || index >= slides.length) return;
      
      const contentWrapper = sliderWrapper.querySelector('.an-cus-banner-content-wraper');
      
      // Remove active class from all slides and content first
      slides.forEach(slide => slide.classList.remove('active'));
      contentSlides.forEach(slide => slide.classList.remove('active'));
      dots.forEach(dot => dot.classList.remove('active'));
      
      // Measure and set height before making content active to prevent layout shift
      if (contentSlides[index] && contentWrapper) {
        // Create a temporary clone to measure height without affecting layout
        const clone = contentSlides[index].cloneNode(true);
        clone.style.position = 'absolute';
        clone.style.visibility = 'hidden';
        clone.style.opacity = '0';
        clone.style.pointerEvents = 'none';
        clone.style.top = '-9999px';
        clone.style.left = '-9999px';
        clone.classList.add('active');
        contentWrapper.appendChild(clone);
        
        const measuredHeight = clone.offsetHeight || 200;
        contentWrapper.removeChild(clone);
        
        // Set wrapper height immediately to prevent shift
        contentWrapper.style.minHeight = measuredHeight + 'px';
      }
      
      // Add active class to current slide and content
      if (slides[index]) slides[index].classList.add('active');
      if (contentSlides[index]) contentSlides[index].classList.add('active');
      if (dots[index]) dots[index].classList.add('active');
      
      // Fine-tune height after a brief delay to account for any layout changes
      if (contentSlides[index] && contentWrapper) {
        requestAnimationFrame(() => {
          const finalHeight = contentSlides[index].offsetHeight;
          if (finalHeight > 0 && Math.abs(finalHeight - parseFloat(contentWrapper.style.minHeight)) > 5) {
            contentWrapper.style.minHeight = finalHeight + 'px';
          }
        });
      }
      
      currentSlide = index;
    }
    
    function nextSlide() {
      const next = (currentSlide + 1) % slides.length;
      showSlide(next);
    }
    
    function prevSlide() {
      const prev = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(prev);
    }
    
    function startAutoplay() {
      if (autoplayEnabled && slides.length > 1) {
        autoplayInterval = setInterval(nextSlide, autoplayDelay);
      }
    }
    
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
      }
    }
    
    // Event listeners
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        stopAutoplay();
        nextSlide();
        startAutoplay();
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        stopAutoplay();
        prevSlide();
        startAutoplay();
      });
    }
    
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        stopAutoplay();
        showSlide(index);
        startAutoplay();
      });
    });
    
    // Pause autoplay on hover
    sliderWrapper.addEventListener('mouseenter', stopAutoplay);
    sliderWrapper.addEventListener('mouseleave', startAutoplay);
    
    // Initialize first slide if not already active
    const firstActiveSlide = sliderWrapper.querySelector('.an-cus-banner-slide.active');
    if (!firstActiveSlide && slides.length > 0) {
      showSlide(0);
    } else if (firstActiveSlide) {
      // Ensure current slide index matches
      const activeIndex = Array.from(slides).indexOf(firstActiveSlide);
      if (activeIndex >= 0) {
        currentSlide = activeIndex;
        showSlide(activeIndex);
      }
    }
    
    // Start autoplay
    startAutoplay();
    
    // Mobile scroll animation
    const mobileScroll = sliderWrapper.querySelector('.an-cus-mobile-scroll');
    if (mobileScroll && typeof $ !== 'undefined') {
      $(mobileScroll).delay(4000).animate({'opacity':'1'},500);
    }
  }
  
  // Initialize all sliders on page
  function initializeAllSliders() {
    const sliders = document.querySelectorAll('.an-cus-banner-slider-wraper[data-section-id]');
    sliders.forEach(slider => {
      const sectionId = slider.getAttribute('data-section-id');
      if (sectionId) {
        initBannerSlider(sectionId);
      }
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllSliders);
  } else {
    // DOM already loaded
    initializeAllSliders();
  }
  
  // Re-initialize on section load (for Shopify theme editor and dynamic loading)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const sectionId = event.detail.sectionId;
      setTimeout(() => {
        initBannerSlider(sectionId);
      }, 100);
    });
    
    document.addEventListener('shopify:section:reorder', function() {
      setTimeout(initializeAllSliders, 100);
    });
  }
  
  // Fallback: Initialize on window load
  window.addEventListener('load', function() {
    setTimeout(initializeAllSliders, 100);
  });
})();
